import { LegalShell } from '@/components/legal/LegalShell';

const URL_RE = /(https?:\/\/[^\s]+|support\.zorobabel@gmail\.com)/g;

function Rich({ text }) {
  return text.split(URL_RE).map((part, i) => {
    if (/^https?:\/\//.test(part)) return <a key={i} href={part} target="_blank" rel="noreferrer" className="text-brand hover:underline break-all">{part}</a>;
    if (part === 'support.zorobabel@gmail.com') return <a key={i} href={`mailto:${part}`} className="text-brand hover:underline">{part}</a>;
    return part;
  });
}

function Block({ b }) {
  if (b.h3) return <h3 className="mt-6 font-display text-base font-semibold text-white">{b.h3}</h3>;
  if (b.ul) return (
    <ul className="ml-5 list-disc space-y-1.5 marker:text-brand">
      {b.ul.map((it) => <li key={it}><Rich text={it} /></li>)}
    </ul>
  );
  return <p><Rich text={b.p} /></p>;
}

export function LegalDocument({ title, subtitle, tagline, sections, testId }) {
  return (
    <LegalShell title={title} subtitle={subtitle} testId={testId}>
      {tagline && <p className="-mt-4 mb-8 text-sm italic text-muted-foreground">{tagline}</p>}
      <div className="space-y-10">
        {sections.map((s, i) => (
          <section key={s.title} id={`section-${i + 1}`} className="space-y-3 text-sm leading-relaxed text-white/80 sm:text-base" data-testid={`${testId}-section-${i + 1}`}>
            <h2 className="font-display text-lg font-bold text-white">{s.title}</h2>
            {s.blocks.map((b, j) => <Block key={j} b={b} />)}
          </section>
        ))}
      </div>
    </LegalShell>
  );
}
